<div class="modal-header">
  <h4 class="modal-title" id="modal-title">{{title}}</h4>
  <button type="button" class="btn-close" aria-label="Close button" aria-describedby="modal-title"
    (click)="modal.dismiss('Cross click')"></button>
</div>
<div class="modal-body">
  <p><strong>{{prefixMessage}} <span class="text-primary">"{{message}}"</span>{{!suffixMessage?'?':''}} {{suffixMessage}}</strong></p>
  <p>All information associated to this {{label}} will be permanently deleted.
    <span class="text-danger">This operation can not be undone.</span>
  </p>
</div>
<div class="modal-footer">
  <button type="button" class="btn btn-outline-secondary" (click)="modal.dismiss('cancel click')">Cancel</button>
  <button type="button" ngbAutofocus class="btn btn-danger" (click)="modal.close(true)">Ok</button>
</div>
